
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M11.285 10.006l-2.041-.409a.467.467 0 01-.375-.457V8.67c.135-.186.26-.436.391-.696.1-.197.25-.494.318-.564.395-.387.817-.868.946-1.494.117-.567 0-.862-.135-1.096 0-.456 0-1.291-.159-1.893-.016-.728-.15-1.138-.484-1.504-.237-.256-.586-.316-.866-.363a1.502 1.502 0 01-.317-.074A3.284 3.284 0 006.985.572c-1.232.046-2.744.828-3.25 2.232-.154.427-.139 1.127-.128 1.69l-.013.327c-.118.234-.235.529-.117 1.095.128.63.55 1.109.944 1.494.068.071.22.37.321.567.133.26.26.509.394.695v.468a.467.467 0 01-.375.457l-2.041.409A2.806 2.806 0 00.47 12.75v.887c0 .515.418.934.933.934h11.2c.514 0 .933-.42.933-.934v-.887c0-1.33-.946-2.485-2.251-2.745z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.003 .572)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    